import { Table, TableWidget } from '@revolut-internal/ui-kit'

import { columns } from './columns'

export const InboxesTable = () => {
  return (
    <TableWidget.Table>
      <Table data={[]} columns={columns} />
    </TableWidget.Table>
  )
}
